import React from 'react';
import DataTableColumnBase, { DataTableColumnBaseProps } from './DataTableColumnBase';

export interface DataTableColumnProps<V = any, K extends keyof V = any> extends DataTableColumnBaseProps {
    prop: K;
    render?: (value: V[K], item: V) => React.ReactNode;
    renderEmptyValues?: boolean;
}

export default class DataTableColumn<V = any, K extends keyof V = any> extends DataTableColumnBase<DataTableColumnProps<V, K>> { }
